import { FiscalPrintEnabledQuery } from '@dreryk/egabinet-invoice-frontend-api';
import { Practitioner, TaxRate } from '@dreryk/egabinet-private-medical-service-frontend-api';

import { useCqrsFind } from '@dreryk/command-query-react-common';
import { Message, MessageType } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';

import { PageLoader } from '../../shared/components/PageLoader';
import { useCqrsSearchPractitionerProvidingPrivateMedicalService } from '../../shared/queries/useCqrsSearchPractitionerProvidingPrivateMedicalServiceQuery';
import { medicalServiceTranslationKeys } from '../../translations';
import { useCqrsSearchTaxRate } from '../shared/queries/useCqrsSearchTaxRate';

type MedicalServiceCreateFormLoaderRenderProps = {
   taxRates: TaxRate[];
   practitioners: Practitioner[];
   fiscalPrintEnabled: boolean;
};

type MedicalServiceCreateFormLoaderProps = {
   readonly children: (renderProps: MedicalServiceCreateFormLoaderRenderProps) => JSX.Element;
};

export const MedicalServiceCreateFormLoader = (props: MedicalServiceCreateFormLoaderProps): JSX.Element | null => {
   const invoiceCreateAvailable = protectFeature('creatingInvoices');

   const { data: taxRates, loading: taxRatesLoading, error: taxRatesError } = useCqrsSearchTaxRate();
   const {
      data: practitioners,
      loading: practitionersLoading,
      error: practitionersError,
   } = useCqrsSearchPractitionerProvidingPrivateMedicalService();

   const {
      data: fiscalPrintEnabled,
      loading: fiscalPrintEnabledLoading,
      error: fiscalPrintEnabledError,
   } = useCqrsFind(() => new FiscalPrintEnabledQuery(), { enabled: invoiceCreateAvailable });

   if (taxRatesLoading || practitionersLoading || fiscalPrintEnabledLoading) {
      return <PageLoader />;
   }

   if (taxRatesError || practitionersError || fiscalPrintEnabledError) {
      return (
         <Message
            testId={'medicalServiceCreateLoaderError'}
            type={MessageType.NEGATIVE}
            label={medicalServiceTranslationKeys.create.form.errors.loadData}
            displayIndicator
         />
      );
   }

   return props.children({
      practitioners: practitioners,
      taxRates: taxRates,
      fiscalPrintEnabled: Boolean(fiscalPrintEnabled),
   });
};
